import * as Sentry from "@sentry/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { SuperTokensWrapper } from "supertokens-auth-react";
import { App } from "./App.tsx";
import "./index.css";

if (import.meta.env.PROD) {
	Sentry.init({
		dsn: import.meta.env.VITE_SENTRY_DSN,
		environment: import.meta.env.MODE,
		sampleRate: 1.0,
		tracesSampleRate: 1.0,
		integrations: [Sentry.browserTracingIntegration()],
	});
}

createRoot(document.getElementById("root")!).render(
	<StrictMode>
		<SuperTokensWrapper>
			<App />
		</SuperTokensWrapper>
	</StrictMode>,
);
